/* ======================================================================== */
/* 67. SliderProjects */
/* ======================================================================== */
var SliderProjects = function ($scope) {

	var $slider = $scope.find('.js-slider-projects');

	if (!$slider.length) {
		return;
	}

	$slider.each(function () {

		var
			$current = $(this),
			counterZeros = $current.data('counter-zeros'),
			lg = window.elementorFrontend ? window.elementorFrontend.config.breakpoints.lg - 1 : 1024,
			md = window.elementorFrontend ? window.elementorFrontend.config.breakpoints.md - 1 : 767;

		var slider = new Swiper($current, {
			autoHeight: $current.data('auto-height') || true,
			speed: $current.data('speed') || 1200,
			preloadImages: false,
			lazy: {
				loadPrevNext: true,
				loadOnTransitionStart: true
			},
			touchRatio: $current.data('touch-ratio') || 3,
			observer: true,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			centeredSlides: $current.data('centered-slides') || false,
			slidesPerView: $current.data('slides-per-view') || 4,
			slidesPerGroup: 1, // compatibility with Swiper 5.x
			autoplay: {
				disableOnInteraction: false,
				enabled: $current.data('autoplay-enabled') || false,
				delay: $current.data('autoplay-delay') || 6000,
			},
			spaceBetween: $current.data('space-between') || 0,
			pagination: {
				el: '.js-slider-projects__dots',
				type: 'bullets',
				bulletElement: 'div',
				clickable: true,
				bulletClass: 'slider__dot',
				bulletActiveClass: 'slider__dot_active'
			},
			navigation: {
				nextEl: '.js-slider-projects__next',
				prevEl: '.js-slider-projects__prev',
			},
			breakpointsInverse: true // compatibility with both Swiper 4.x and 5.x
		});

		slider.params.breakpoints = {
			0: {
				slidesPerView: $current.data('slides-per-view-mobile'),
				spaceBetween: $current.data('space-between-mobile'),
				centeredSlides: $current.data('centered-slides-mobile'),
			},
			[md]: {
				slidesPerView: $current.data('slides-per-view-tablet'),
				spaceBetween: $current.data('space-between-tablet'),
				centeredSlides: $current.data('centered-slides-tablet'),
			},
			[lg]: {
				centeredSlides: $current.data('centered-slides') || false,
				slidesPerView: $current.data('slides-per-view') || 4,
				spaceBetween: $current.data('space-between') || 0,
			}
		};

		slider.update();

		// update height after images are loaded
		slider.on('lazyImageReady', function () {
			slider.update();
		});

		// cursor follower position adjustment
		if (typeof window.InteractiveCursor !== 'undefined') {
			slider.on('touchMove', function (e) {

				window.InteractiveCursor.mouseX = e.clientX;
				window.InteractiveCursor.mouseY = e.clientY;
			});
		}

		$slider.imagesLoaded().progress({
			background: true
		}, function (e) {
			setTimeout(function () {
				slider.update();
			}, 300);
		});

		renderSliderDots(slider, $scope.find('.js-slider-projects__dots'));
		renderSliderCounter(
			slider,
			$scope.find('.js-slider-projects__counter-current'),
			'',
			$scope.find('.js-slider-projects__counter-total'),
			'',
			counterZeros
		);

	});

}
